varying vec2 vUv;

void main() {
  vec3 localPosition = position;

  gl_Position = projectionMatrix * modelViewMatrix * vec4(localPosition, 1.0);

  vUv = uv;
}